module.exports = __webpack_public_path__ + "img/cpjs-img1.2179f917.png";